import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { IoChevronDown, IoChevronUp } from "react-icons/io5";

import lowerCase from "lodash/lowerCase";

import Badge from "../common/Badge";

export const getClassName = (priority) => {
  if (priority === "low") {
    return "success";
  }
  if (priority === "normal") {
    return "warning";
  }
  return "danger";
};

const SupportTicketHeader = ({ supportTicket, open, toggleShow }) => {
  const className = getClassName(lowerCase(supportTicket.request_priority));

  return (
    <Container>
      <div>
        <h5>
          <strong>Ticket Number: </strong>
          <Link to={`/app/support-tickets/${supportTicket._id}`}>
            {supportTicket.support_ticket_number}
          </Link>
        </h5>
        <h5>
          <strong>Request Priority: </strong>
          <Badge className={`ticket ${className}`}>
            {supportTicket.request_priority}
          </Badge>
        </h5>
      </div>
      <button onClick={toggleShow}>
        {!open ? <IoChevronDown /> : <IoChevronUp />}
      </button>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 15px;
  div {
    display: flex;
    gap: 20px;
  }
  button {
    background: transparent;
    border: none;
  }
  svg {
    vertical-align: middle;
  }
  .ticket {
    margin-left: 5px;
  }
  strong {
    color: #999;
  }
  @media screen and (max-width: 812px) {
    text-align: left;
    padding: 0;
    .badge {
      display: inline-block;
      height: 10px !important;
      width: 10px !important;
      min-width: auto !important;
      border-radius: 50% !important;
      padding: 0;
      margin: 0 auto;
      color: transparent !important;
    }
  }
`;

SupportTicketHeader.propTypes = {
  supportTicket: PropTypes.object,
  open: PropTypes.bool,
  toggleShow: PropTypes.func
};

export default SupportTicketHeader;
